const SectionTestimonials = Class(
	/**
	 * @lends {SectionTestimonials#}
	 */
	{
		menuItem: 'testimonials',

		_MENU: ['event', 'local', 'corporate', 'online'],

		route: function() {
			this._type = this.url.shift();
			this._id = this.url.shift();
		},

		draw() {
			this.node = mkE({
				tag: 'div',
				id: 'testimonials',
				els: [
					{
						tag: 'header',
						els: [
							{
								tag: 'div',
								className: 'container',
								els: [
									{
										tag: 'h1',
										text: D.Lang.get('testimonials.section.header')
									},
									this._tabs = new T.MainTabs()
								]
							}
						]
					},
					this._content = mkE({
						tag: 'div',
						className: 'container content'
					})
				]
			}).append(this.layout.ct());

			this.meta.setSection(`/testimonials/${this._type}`);

			this._mGetQuotes = new DR.web.GetQuotes();
			this._mGetQuotes.pg = 1;
			this._mGetQuotes.count = 100;
			this._mGetQuotes.select = [
				new DR.roadgames.select.Image().original()
			];

			this.apiCall.addMethod(this._mGetQuotes);

			this.apiCall.onLoad = this.onApiCallRe;
			this.apiCall.call();
		},

		onApiCallRe() {
			let menuItems = [];
			let type = this._type;
			let selected = null;

			for (let i = 0; i < this._MENU.length; i++) {
				let key = this._MENU[i];
				if (key === type) {
					selected = key;
				}
				if (this._getQuotes(key).length === 0) {
					continue;
				}
				menuItems.push({
					name: key,
					url: D.url(`/testimonials/${key}/`),
					caption: D.Lang.get(`testimonials.section.menu.${key}`)
				});
			}

			if (selected === null) {
				selected = menuItems[0].name;
			}

			this._tabs.setItems(menuItems);
			this._tabs.setActive(selected);

			this.drawTab(selected);

			this.ready();
		},

		/**
		 * @param {string} type
		 * @returns {Array<DR.web.struct.Quote>}
		 * @private
		 */
		_getQuotes(type) {
			return this._mGetQuotes.re.quotes.filter(quote => {
				return quote.type === type;
			}) || [];
		},

		drawTab(type) {
			clearNode(this._content);
			let quotes = this._getQuotes(type);
			if (type === 'corporate') {
				quotes = quotes.concat(this._getQuotes('business'));
			}
			if (!quotes.length) {
				return null;
			}
			for (let i = 0; i < quotes.length; i++) {
				this.drawItem(quotes[i]);
			}
		},

		/**
		 * @param {DR.web.struct.Quote} data
		 */
		drawItem(data) {
			let url = null;
			const event_id = Number(D.Lang.get(`testimonials.${data.id}.event_id`, 0));
			if (event_id > 0) {
				url = D.url(`/event/${event_id}`);
			}
			mkE({
				tag: 'article',
				id: `testimonial-${data.id}`,
				className: 'testimonial',
				els: [
					{
						tag: 'div',
						className: 'header',
						els: [
							{
								tag: 'img',
								className: 'image',
								alt: D.Lang.get(`testimonials.${data.id}.event`),
								src: data.image.original
							},
							{
								tag: 'h4',
								className: 'person',
								text: D.Lang.get(`testimonials.${data.id}.name`)
							},
							{
								tag: 'div',
								className: 'position',
								text: D.Lang.get(`testimonials.${data.id}.position`)
							}
						]
					},
					{
						tag: 'div',
						className: 'text',
						text: D.Lang.get(`testimonials.${data.id}.full_text`)
					}
				]
			}).append(this._content);
		},

		onShow() {
			const id = this._id || this.url.get.v('id') || null;
			if (id === null) {
				return;
			}
			D.scrollIntoView(document.getElementById(`testimonial-${id}`));
		}

	},
	Section
);
